/* global VXConfig */
import FluxEventEmitter from '../FluxEventEmitter';
import assign from 'object-assign';
import { doFetch, urlWithQuery } from '../../utils/CommonUtils';
import Constants from '../Constants';
import Dispatcher from '../Dispatcher';
import DailyBonusActionTypes from '../actions/Types/DailyBonusActionTypes';
import Flux from '../Flux';
import { doVxqlRequest, LANG } from './VxqlStore/common.js';
import VXGameVxqlStore from './VxqlStore/VXGameVxqlStore.js';
import {
	GuestInitData,
	BoughtGiftsForGuest,
	FilteredModels,
	PreferencedModel,
	ModelsV2,
	ModelsV3,
	ModelsV3WithOnlineFilter,
	FilteredVideos,
	GlobalSearchBasic,
	GlobalSearchExtended,
	Suggestions,
	ActorSearch,
	VideoSearch,
	ASMRById,
	ASMRSearch,
	MediathekSearch,
	BlogSearch,
	StoreSearchPattern,
	CollectionsV2,
	DailyBonuses,
	AddTagToAlbum,
	SendFeatureFeedback,
	AddVideoLike,
	AddVideoDislike,
	AddAlbumView,
	AddMabAlbumView,
	AddGalleryLike,
	AddGalleryDislike,
	GuestVideoTime,
	BonusModels,
	ConsumedOffers,
	MabRecommendations,
	VideosFromVXQL,
	VideosWithModelFilter,
	TVSeries,
	PhotoAlbums,
	TVMediathekVideoRecommendationsByHashId,
	MediathekVideos,
	ActorChatRatings,
	ActorRecommendedModelsExtended,
	ActorRecommendedModels,
	ActorInterviews,
	VideoRecommendationsByActorId,
	VideoRecommendationsByAlbumId,
	ConversionChatActors,
	FreeChatDuration,
	UberFlow,
	FavoriteModels,
	FavoriteModelsBlock,
	RecommendedModels,
	Benefits,
	MyVisitXSidebarData,
	ActorHeatMaps,
	Banner,
	UserActivityData,
	BonusCode,
	RemainingBonusCodes,
	EasterEvent,
	Vip30ValueHistory,
	ProfileLiveShowTicket,
	BuyChatTicket,
	RemoveChatTicket,
	CamShows,
	DailyBonusFromApi,
	VxqlContestsFromApi,
	ContestVotingModule,
	GuestAddVote,
	GuestDeleteVote,
	InteractiveContent365,
	DailyBonusEventConfig,
	VideoStars,
	ClaimActorGiftCalendarReward,
	LegalTexts,
	Seo,
	ModelsV3Total,
	SubmitUberPreferences,
} from './Vxql.Queries.js';

const BONUS_SERVICE_URL = VXConfig.services.bonusCode.url;
const VXONE_SESSION_ID = VXConfig.vxoneSessionId;

let _dailybonusData = {};
let _contestsData = {};
let eventConfigPromise = null;

const heatMapsPromise = {};

/**
 *
 * @param {string} query
 * @param {Object} variables
 * @param {Object} queryParam
 * @returns {Promise}
 */
function doBonusCodeRequest(query, variables = null, queryParam = {}) {
	const queryObject = {};
	queryObject.query = query;

	if (variables) {
		queryObject.variables = variables;
	}

	const init = {
		headers: { Authorization: 'Bearer ' + VXONE_SESSION_ID },
	};

	const requestUrl = urlWithQuery(BONUS_SERVICE_URL, {
		...queryParam,
		language: LANG,
	});

	return doFetch(requestUrl, queryObject, Constants.HttpMethods.POST, false, init);
}

function getGuestInitData(callback) {
	doVxqlRequest(GuestInitData).then(callback);
}

/**
 *
 * @param {Function} callback
 */
function getBoughtGiftsForGuest(callback) {
	doVxqlRequest(BoughtGiftsForGuest).then(callback);
}

/**
 *
 * @param {int} amount
 * @param {object} filter
 * @param {Function} callback
 * @param {string} order
 */
function getFilteredModels(amount, filter, callback, order = 'online_ranking') {
	const args = { amount: amount, filter: filter, order };
	doVxqlRequest(FilteredModels, args).then(callback);
}

function getPreferencedModel(filter, callback) {
	doVxqlRequest(PreferencedModel, { first: 3, filter }).then(callback);
}

/**
 *
 * @param filter
 * @returns {Promise}
 */
function getModelsV3Total(filter) {
	const args = { filter };
	return doVxqlRequest(ModelsV3Total, args);
}

/**
 *
 * @param {int} first
 * @param {int} last
 * @param {int} offset
 * @param {string} order
 * @param {object} filter
 * @param {string} preset
 * @param isV3
 * @param onlineFilter
 */
function getModels(first, last, offset, order, filter, preset, isV3, onlineFilter) {
	if (isV3) {
		return getModelsV3(first, last, offset, order, filter, onlineFilter);
	}

	const args = { first, last, offset, order, filter, preset };

	return doVxqlRequest(ModelsV2, args);
}

/**
 *
 * @param {int} first
 * @param {int} last
 * @param {int} offset
 * @param {string} order
 * @param {object} filter
 * @param onlineFilter
 */
function getModelsV3(first, last, offset, order, filter, onlineFilter) {
	const args = { first, last, offset, order, filter, onlineFilter };
	const query = onlineFilter ? ModelsV3WithOnlineFilter : ModelsV3;
	return doVxqlRequest(query, args);
}

/**
 *
 * @param {int} amount
 * @param {object} filter
 * @param {Function} callback
 * @param {string} order
 * @param {array} modelIds
 * @param ids
 */
function getFilteredVideos(amount, filter, callback, order, modelIds, ids) {
	const args = { amount: amount, filter: filter, order: order, modelIds: modelIds, ids };
	doVxqlRequest(FilteredVideos, args).then(callback);
}

/**
 *
 * @param {string} searchPattern
 * @param {bool} isExtended
 * @param {Function} callback
 */
function processGlobalSearch(searchPattern, isExtended, callback) {
	const query = isExtended ? GlobalSearchExtended : GlobalSearchBasic;
	doVxqlRequest(query, { searchPattern: searchPattern }).then(callback);
}

/**
 *
 * @param {Function} callback
 */
function processSuggestions(callback) {
	doVxqlRequest(Suggestions).then(callback);
}

/**
 *
 * @param {string} searchPattern
 * @param {Function} callback
 * @param {int} first
 * @param {int} offset
 * @param {?string} order
 * @param {Object} filter
 */
function processActorSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
	doVxqlRequest(ActorSearch, { searchPattern: searchPattern, first: first, offset: offset, order: order, filter: filter }).then(callback);
}

/**
 *
 * @param {string} searchPattern
 * @param {Function} callback
 * @param {int} first
 * @param {int} offset
 * @param {?string} order
 * @param {Object} filter
 */
function processVideoSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
	doVxqlRequest(VideoSearch, { searchPattern: searchPattern, first: first, offset: offset, order: order, filter: filter }).then(callback);
}

function getASMRById(id, callback) {
	doVxqlRequest(ASMRById, { id: id }).then(callback);
}

/**
 *
 * @param {string} searchPattern
 * @param {Function} callback
 * @param {int} first
 * @param {int} offset
 * @param {?string} order
 * @param {Object} filter
 */
function processASMRSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
	doVxqlRequest(ASMRSearch, { searchPattern: searchPattern, first: first, offset: offset, order: order, filter: filter }).then(callback);
}

/**
 *
 * @param {string} searchPattern
 * @param {Function} callback
 * @param {int} first
 * @param {int} offset
 * @param {?string} order
 * @param {Object} filter
 */
function processMediathekSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
	doVxqlRequest(MediathekSearch, { searchPattern: searchPattern, first: first, offset: offset, order: order, filter: filter }).then(callback);
}

/**
 *
 * @param {string} searchPattern
 * @param {Function} callback
 * @param {int} first
 * @param {int} offset
 * @param {?string} order
 * @param {Object} filter
 */
function processBlogSearch(searchPattern, callback, first = 15, offset = 0, order = null, filter = null) {
	doVxqlRequest(BlogSearch, { searchPattern: searchPattern, first: first, offset: offset, order: order, filter: filter }).then(callback);
}

function storeSearchPattern(searchPattern, callback) {
	doVxqlRequest(StoreSearchPattern, { searchPattern: searchPattern }).then(callback);
}

/**
 * @param args
 * @param {function} callback
 */
async function getCollectionsV2(args, callback) {
	const queryParams = {};
	if (args.firstModels === 0) {
		queryParams.cache = 1;
	}
	return doVxqlRequest(CollectionsV2, { ...args }, queryParams).then(callback);
}

/**
 * @param {String} date
 * @param {Function} callback
 */
function getDailyBonuses(date, callback) {
	doVxqlRequest(DailyBonuses, null, date ? { qmdate: date } : {})
		.then((result) => {
			_dailybonusData[date] = result.data.dailyBonus;
			return result;
		})
		.then(callback);
}

/**
 *
 * @param {int} albumId
 * @param {array} tagIds
 * @param {Function} callback
 */

function addTagToAlbum(albumId, tagIds, callback) {
	doVxqlRequest(AddTagToAlbum, { albumId: albumId, tagIds: tagIds }).then(callback);
}

/**
 *
 * @param {int} featureId
 * @param {string} rating
 * @param {string} text
 * @param {string} url
 * @param {Function} callback
 */
function sendFeatureFeedback(featureId, rating, text, url, callback) {
	doVxqlRequest(SendFeatureFeedback, { featureId, rating, text, url }).then(callback);
}

/**
 *
 * @param {int} id
 * @param {function} callback
 */

function addVideoLike(id, callback) {
	doVxqlRequest(AddVideoLike, { id }).then(callback);
}

/**
 *
 * @param {int} id
 * @param {function} callback
 */

function addVideoDislike(id, callback) {
	doVxqlRequest(AddVideoDislike, { id }).then(callback);
}

/**
 *
 * @param {int} id
 */

function addAlbumView(id) {
	doVxqlRequest(AddAlbumView, { id });
}

function addMabAlbumView(id) {
	doVxqlRequest(AddMabAlbumView, { id });
}

/**
 *
 * @param {int} id
 * @param {function} callback
 */

function addGalleryLike(id, callback) {
	doVxqlRequest(AddGalleryLike, { id }).then(callback);
}

/**
 *
 * @param {int} id
 * @param {function} callback
 */

function addGalleryDislike(id, callback) {
	doVxqlRequest(AddGalleryDislike, { id }).then(callback);
}

function getGuestVideoTime(chatId, callback) {
	doVxqlRequest(GuestVideoTime, { chatId }).then(callback);
}

/**
 *
 * @param {Function} callback
 * @param {Array} genders
 */
function getBonusModels(callback, genders) {
	const dateFrom = new Date();
	dateFrom.setDate(1);

	const variables = {
		dateFrom: dateFrom.toISOString(),
		dateTo: new Date(dateFrom.getFullYear(), dateFrom.getMonth() + 1, 0).toISOString(),
		genders: genders,
		language: VXConfig.language.toUpperCase(),
	};

	doVxqlRequest(BonusModels, variables).then(callback);
}

/**
 *
 * @param {Function} callback
 * @param {Number} first
 * @param {Number} offset
 * @param {String|null} dateFrom
 * @param {String|null} dateTo
 */
function getConsumedOffers(callback, first = 31, offset = 0, dateFrom = null, dateTo = null) {
	doVxqlRequest(ConsumedOffers, { first, offset, dateFrom, dateTo }).then(callback);
}

function getMabRecommendationsFromVXQL(count, mode) {
	const variables = {
		count,
		mode,
	};

	return doVxqlRequest(MabRecommendations, variables);
}

/**
 * @param {Object} filter
 * @param {string} order
 * @param {number} count
 * @param {number} offset
 * @return {Promise}
 */
function getVideosFromVXQL(filter, order, count, offset) {
	const variables = {
		count,
		order,
		offset,
		filter,
	};

	return doVxqlRequest(VideosFromVXQL, variables);
}

function getVideosWithModelFilterFromVXQL(filter, modelFilter, order, count, offset) {
	const variables = {
		count,
		order,
		offset,
		filter,
		modelFilter,
	};

	return doVxqlRequest(VideosWithModelFilter, variables);
}

/**
 * @param {Object} filter
 * @param {string} order
 * @param {number} count
 * @param {number} offset
 * @return {Promise}
 */
function getPhotoAlbumsFromVXQL(filter, order, count, offset) {
	const variables = {
		count,
		order,
		offset,
		filter,
	};

	return doVxqlRequest(PhotoAlbums, variables);
}

/**
 * @param {number} count
 * @param {number} offset
 * @return {Promise}
 */
function getTVSeriesFromVXQL(count, offset) {
	const variables = {
		count,
		offset,
	};

	return doVxqlRequest(TVSeries, variables, { cache: 1 });
}

/**
 * @param {string} hashId
 * @param {number} count
 * @return {Promise}
 */
function getTVMediathekVideoRecommendationsByHashIdFromVXQL(hashId, count) {
	const variables = {
		count,
		hashId,
	};

	return doVxqlRequest(TVMediathekVideoRecommendationsByHashId, variables);
}

function getMediathekVideosFromVXQL(filter, count, offset) {
	const variables = {
		count,
		offset,
		filter,
	};

	return doVxqlRequest(MediathekVideos, variables);
}

/**
 * @param {Number} actorId
 * @returns {Promise}
 */
function getActorChatRatings(actorId) {
	return doVxqlRequest(ActorChatRatings, { actorId });
}

/**
 * @param actorId
 * @param first
 * @param {Boolean} isExtended
 * @param {Number} ageRating
 * @return {Promise}
 */
function getActorRecommendedModels(actorId, first = 4, isExtended = false, ageRating = 16) {
	const query = isExtended ? ActorRecommendedModelsExtended : ActorRecommendedModels;

	return doVxqlRequest(query, { actorId, first, ageRating });
}

/**
 * @param {Number} actorId
 * @param {String} imageSize
 * @param {Boolean} placeholder
 * @param {String} durationFormat
 * @return {Promise}
 */
function _loadActorInterviews(
	actorId,
	imageSize = Constants.Interviews.IMAGE_SIZE_720,
	placeholder = true,
	durationFormat = Constants.Interviews.DURATION_SEC,
) {
	return doVxqlRequest(ActorInterviews, {
		actorId,
		imageSize,
		placeholder,
		durationFormat,
	});
}

/**
 * @param {number} actorId
 * @param {number} countFromSameActor
 * @param {number} countFromDifferentActor
 * @return {Promise}
 */
function getVideoRecommendationsByActorId(actorId, countFromSameActor, countFromDifferentActor) {
	const variables = {
		actorId,
		countFromSameActor,
		countFromDifferentActor,
		fromSameActor: countFromSameActor > 0,
		fromDifferentActor: countFromDifferentActor > 0,
	};

	return doVxqlRequest(VideoRecommendationsByActorId, variables);
}

/**
 * @param {number} albumId
 * @param {number} countFromSameActor
 * @param {number} countFromDifferentActor
 * @return {Promise}
 */
function getVideoRecommendationsByAlbumId(albumId, countFromSameActor, countFromDifferentActor) {
	const variables = {
		albumId,
		countFromSameActor,
		countFromDifferentActor,
		fromSameActor: countFromSameActor > 0,
		fromDifferentActor: countFromDifferentActor > 0,
	};

	return doVxqlRequest(VideoRecommendationsByAlbumId, variables);
}

/**
 *
 * @param {number} first
 * @param {number} offset
 * @returns {Promise}
 */
function getConversionChatActors(first = 30, offset = 0) {
	return doVxqlRequest(ConversionChatActors, { first: first, offset: offset });
}

/**
 * @param {function} callback
 * @param {number} actorId
 */
function loadFreeChatDuration(callback, actorId) {
	doVxqlRequest(FreeChatDuration, { actorId: actorId }).then((result) => callback(result, actorId));
}

/**
 * @param {number} actorId
 * @returns {Promise}
 */
function getUberFlow(actorId) {
	return doVxqlRequest(UberFlow, { actorId: actorId });
}

/**
 * @param {Object} input
 * @returns {Promise}
 */
function submitUberPreferences(input) {
	return doVxqlRequest(SubmitUberPreferences, { input });
}

/**
 * @param {function} callback
 * @param {boolean} feedOnly
 */
function getFavoriteModels(callback, feedOnly = false) {
	doVxqlRequest(FavoriteModels, { feedOnly }).then((result) => callback(result));
}

function getFavoriteModelsBlock(first = 50, callback, feedOnly = false) {
	doVxqlRequest(FavoriteModelsBlock, { feedOnly, first }).then((result) => callback(result));
}

/**
 *
 * @param first
 * @param feedOnly
 * @param callback
 */
function getRecommendedModels(first, feedOnly, callback) {
	doVxqlRequest(RecommendedModels, { first, feedOnly }).then((result) => callback(result));
}

/**
 * @param {function} callback
 */
function getBenefits(callback) {
	doVxqlRequest(Benefits, {}).then((result) => callback(result));
}

/**
 * @param {function} callback
 */
function getMyVisitXSidebarData(callback) {
	doVxqlRequest(MyVisitXSidebarData, {}).then((result) => callback(result));
}

/**
 *
 * @param {number} actorId
 * @returns {Promise}
 */
function getActorHeatMaps(actorId) {
	if (!heatMapsPromise[actorId]) {
		heatMapsPromise[actorId] = doVxqlRequest(ActorHeatMaps, { actorId });
		heatMapsPromise[actorId].then((result) => {
			delete heatMapsPromise[actorId];
			return result;
		});
	}
	return heatMapsPromise[actorId];
}

/**
 *
 * @param {bool}     mobile
 * @param {string}   routeName
 * @param {array}    routeArgs
 * @param {function} callback
 */
function loadBanner(mobile, routeName, routeArgs, callback) {
	const params = {
		mobile,
		routeName,
		routeArgs,
	};
	doVxqlRequest(Banner, params).then(callback);
}

const CHANGE_EVENTS = {
	DailyBonusLoaded: 'DailyBonusLoaded',
};

/**
 * @param activityId
 * @param {Function} callback
 */
function getUserActivityData(activityId, callback) {
	const args = { id: activityId };
	doVxqlRequest(UserActivityData, args).then((result) => callback(result));
}

/**
 *
 * @param {string} code
 * @param {Function} callback
 */
function getBonusCode(code, callback) {
	doBonusCodeRequest(BonusCode, { code }).then((result) => callback(result));
}

/**
 *
 * @param {Function} callback
 */
function getRemainingBonusCodes(callback) {
	doBonusCodeRequest(RemainingBonusCodes, {}).then((result) => callback(result));
}

/**
 * @param easterId
 * @param {Function} callback
 */
function getEasterEvent(easterId, callback) {
	const args = { id: easterId };
	doVxqlRequest(EasterEvent, args).then((result) => callback(result));
}

function getVip30ValueHistory(callback) {
	doVxqlRequest(Vip30ValueHistory, {}).then((result) => callback(result));
}

/**
 * @param {number} actorId
 * @param {Function} callback
 */
function getProfileLiveShowTicket(actorId, callback) {
	const args = { id: actorId };

	doVxqlRequest(ProfileLiveShowTicket, args).then((result) => {
		let data = [];
		if (result.data && result.data.model.ticketChatList && result.data.model.ticketChatList.length > 0) {
			data = result.data.model.ticketChatList;
		}
		callback(data);
	});
}

function buyChatTicket(ticket, creationType = Flux.Constants.TicketCreationType.CHAT_TICKET, callback) {
	const args = { ...ticket, creationType };
	doVxqlRequest(BuyChatTicket, args).then((result) => {
		let data;
		if (result.data && result.data.guest && result.data.guest.buyChatTicket) {
			data = result.data.guest.buyChatTicket;
		}
		callback(data);
	});
}

function removeChatTicket(ticket, callback) {
	const args = { ...ticket };
	doVxqlRequest(RemoveChatTicket, args).then((result) => {
		let data;
		if (result?.data?.guest?.removeChatTicket) {
			data = result.data.guest.removeChatTicket;
		}
		callback(data);
	});
}

function getCamShows({ endDateFrom, order, startDateTo, first, internal, callback }, cache) {
	const queryParams = {};
	if (cache) {
		queryParams.cache = 1;
	}

	doVxqlRequest(CamShows, { endDateFrom, order, startDateTo, first, internal }, queryParams).then((result) => callback(result));
}

function getVideoStars(first = 100) {
	return doVxqlRequest(VideoStars, { first: first });
}

function claimActorGiftCalendarReward(actorId, qmDay) {
	return doVxqlRequest(ClaimActorGiftCalendarReward, { actorId: actorId, qmday: qmDay });
}

function getLegalTexts(filter, first, offset, callback) {
	const args = { filter, first, offset };
	doVxqlRequest(LegalTexts, args).then((result) => callback(result));
}

function getSeo(tags, callback) {
	const args = { tags };
	doVxqlRequest(Seo, args).then((result) => callback(result));
}

const VxqlStore = assign({}, FluxEventEmitter.prototype, {
	EVENTS: CHANGE_EVENTS,

	getGuestInitData(callback) {
		getGuestInitData(callback);
	},
	getBoughtGiftsForGuest(callback) {
		getBoughtGiftsForGuest(callback);
	},
	getFilteredModels(amount, filter, callback) {
		getFilteredModels(amount, filter, callback);
	},
	getModelsV3Total(filter) {
		return getModelsV3Total(filter);
	},
	getModels(first, last, offset, order, filter, preset, isV3, onlineFilter) {
		return getModels(first, last, offset, order, filter, preset, isV3, onlineFilter);
	},
	getPreferencedModel(filter, callback) {
		getPreferencedModel(filter, callback);
	},
	getFilteredVideos(amount, filter, callback, order, modelIds, ids) {
		getFilteredVideos(amount, filter, callback, order, modelIds, ids);
	},
	processGlobalSearch(searchPattern, isExtended, callback) {
		processGlobalSearch(searchPattern, isExtended, callback);
	},
	processSuggestions(callback) {
		processSuggestions(callback);
	},
	storeSearchPattern(searchPattern, callback) {
		storeSearchPattern(searchPattern, callback);
	},
	getDailyBounes(callback) {
		getDailyBonuses(null, callback);
	},
	/**
	 * @param {String} date
	 * @param {Function} callback
	 */
	getDailyBounesFromApi: function (date, callback) {
		doVxqlRequest(DailyBonusFromApi, null, date ? { qmdate: date } : {})
			.then((result) => {
				_dailybonusData[date] = result.data.dailyBonus;
				return result;
			})
			.then(callback);
	},
	getDailybonusFromStore: function (date) {
		return Object.hasOwn(_dailybonusData, date) ? _dailybonusData[date] : [];
	},
	/**
	 * @param {Boolean} activeIsSpecial
	 * @param {Function} callback
	 */
	getVxqlContestsFromApi: function (activeIsSpecial, callback) {
		doVxqlRequest(VxqlContestsFromApi, { activeIsSpecial: activeIsSpecial }, { cache: 1 })
			.then((result) => {
				_contestsData = result.data.contests;
				return result;
			})
			.then(callback);
	},
	getContestVotingModule: function (votingId, callback) {
		doVxqlRequest(ContestVotingModule, { votingId }).then(callback);
	},
	guestAddVote: function (votingId, votingOptionKey) {
		doVxqlRequest(GuestAddVote, { votingId, votingOptionKey });
	},
	guestDeleteVote: function (votingId, votingOptionKey) {
		doVxqlRequest(GuestDeleteVote, { votingId, votingOptionKey });
	},
	getVxqlContestsFromStore: function () {
		return _contestsData;
	},
	getBonusModels(callback, genders = Object.values(Flux.Constants.ActorGenderType)) {
		getBonusModels(callback, genders);
	},
	/**
	 * @param {Function} callback
	 * @param {Number} first
	 * @param {Number} offset
	 * @param {String|null} dateFrom
	 * @param {String|null} dateTo
	 */
	getConsumedOffers(callback, first = 31, offset = 0, dateFrom = null, dateTo = null) {
		getConsumedOffers(callback, first, offset, dateFrom, dateTo);
	},
	/**
	 * @param {Number} actorId
	 * @returns {Promise}
	 */
	getActorChatRatings(actorId) {
		return getActorChatRatings(actorId);
	},
	/**
	 * @param {Number} actorId
	 * @param {Number} first
	 * @param {Boolean} isExtended
	 * @param {Number} ageRating
	 * @returns {Promise}
	 */
	getActorRecommendedModels(actorId, first = 4, isExtended = false, ageRating = 16) {
		return getActorRecommendedModels(actorId, first, isExtended, ageRating);
	},
	sendFeatureFeedback(featureId, rating, text, url, callback) {
		sendFeatureFeedback(featureId, rating, text, url, callback);
	},
	addVideoLike(id, callback) {
		addVideoLike(id, callback);
	},
	addVideoDislike(id, callback) {
		addVideoDislike(id, callback);
	},
	addAlbumView(id) {
		addAlbumView(id);
	},
	addMabAlbumView(id) {
		addMabAlbumView(id);
	},
	addGalleryLike(id, callback) {
		addGalleryLike(id, callback);
	},
	addGalleryDislike(id, callback) {
		addGalleryDislike(id, callback);
	},
	getGuestVideoTime(chatId, callback) {
		getGuestVideoTime(chatId, callback);
	},
	processActorSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
		processActorSearch(searchPattern, callback, first, offset, order, filter);
	},
	processVideoSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
		processVideoSearch(searchPattern, callback, first, offset, order, filter);
	},
	getASMRById(id, callback) {
		getASMRById(id, callback);
	},
	processASMRSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
		processASMRSearch(searchPattern, callback, first, offset, order, filter);
	},
	processMediathekSearch(searchPattern, callback, first = 30, offset = 0, order = null, filter = null) {
		processMediathekSearch(searchPattern, callback, first, offset, order, filter);
	},
	processBlogSearch(searchPattern, callback, first = 15, offset = 0, order = null, filter = null) {
		processBlogSearch(searchPattern, callback, first, offset, order, filter);
	},
	getVideoRecommendationsByActorId(actorId, countFromSameActor, countFromDifferentActor) {
		return getVideoRecommendationsByActorId(actorId, countFromSameActor, countFromDifferentActor);
	},
	getVideoRecommendationsByAlbumId(albumId, countFromSameActor, countFromDifferentActor) {
		return getVideoRecommendationsByAlbumId(albumId, countFromSameActor, countFromDifferentActor);
	},
	getConversionChatActors(first = 30, offset = 0) {
		return getConversionChatActors(first, offset);
	},

	getUserActivityData(activityId, callback) {
		getUserActivityData(activityId, callback);
	},

	getBonusCode(code, callback) {
		getBonusCode(code, callback);
	},

	getRemainingBonusCodes(callback) {
		getRemainingBonusCodes(callback);
	},

	getEasterEvent(eventId, callback) {
		getEasterEvent(eventId, callback);
	},

	getProfileLiveShowTicket(actorId, callback) {
		getProfileLiveShowTicket(actorId, callback);
	},

	buyChatTicket(ticket, creationType, callback) {
		buyChatTicket(ticket, creationType, callback);
	},

	removeChatTicket(ticket, callback) {
		removeChatTicket(ticket, callback);
	},

	getVip30ValueHistory(callback) {
		getVip30ValueHistory(callback);
	},

	loadBanner(mobile, routeName, routeArgs, callback) {
		loadBanner(mobile, routeName, routeArgs, callback);
	},

	getCamShows({ endDateFrom, order, startDateTo, first, internal, callback }, cache = false) {
		getCamShows({ endDateFrom, order, startDateTo, first, internal, callback }, cache);
	},

	/**
	 * @param actorId
	 */
	getActorHeatMaps(actorId) {
		return getActorHeatMaps(actorId);
	},

	/**
	 * @param {number} albumId
	 * @param {Array} tags
	 * @param {function} callback
	 */
	addTagToAlbum(albumId, tags, callback) {
		addTagToAlbum(albumId, tags, callback);
	},

	getCollectionsV2(args, callback) {
		return getCollectionsV2(args, callback);
	},

	/**
	 * @param filter
	 * @param order
	 * @param count
	 * @param offset
	 */
	getVideosFromVXQL(filter, order, count, offset) {
		return getVideosFromVXQL(filter, order, count, offset);
	},

	getMabRecommendationsFromVXQL(count, mode) {
		return getMabRecommendationsFromVXQL(count, mode);
	},

	getVideosWithModelFilterFromVXQL(filter, modelFilter, order, count, offset) {
		return getVideosWithModelFilterFromVXQL(filter, modelFilter, order, count, offset);
	},

	/**
	 * @param filter
	 * @param order
	 * @param count
	 * @param offset
	 */
	getPhotoAlbumsFromVXQL(filter, order, count, offset) {
		return getPhotoAlbumsFromVXQL(filter, order, count, offset);
	},

	/**
	 * @param count
	 * @param offset
	 */
	getTVSeriesFromVXQL(count, offset) {
		return getTVSeriesFromVXQL(count, offset);
	},

	getTVMediathekVideoRecommendationsByHashIdFromVXQL(hashId, count) {
		return getTVMediathekVideoRecommendationsByHashIdFromVXQL(hashId, count);
	},

	getMediathekVideosFromVXQL(filter, count, offset) {
		return getMediathekVideosFromVXQL(filter, count, offset);
	},

	/**
	 *
	 * @param {function} callback
	 * @param {number} actorId
	 */
	loadFreeChatDuration(callback, actorId) {
		loadFreeChatDuration(callback, actorId);
	},

	getUberFlow(actorId) {
		return getUberFlow(actorId);
	},

	submitUberPreferences(input) {
		return submitUberPreferences(input);
	},

	/**
	 *
	 * @param {function} callback
	 * @param {boolean} feedOnly
	 */
	getFavoriteModels(callback, feedOnly = false) {
		getFavoriteModels(callback, feedOnly);
	},

	getFavoriteModelsBlock(first, callback, feedOnly = false) {
		getFavoriteModelsBlock(first, callback, feedOnly);
	},

	/**
	 *
	 * @param first
	 * @param feedOnly
	 * @param callback
	 */
	getRecommendedModels(first, feedOnly, callback) {
		getRecommendedModels(first, feedOnly, callback);
	},

	/**
	 *
	 * @param {function} callback
	 */
	getBenefits(callback) {
		getBenefits(callback);
	},

	/**
	 *
	 * @param {function} callback
	 */
	getMyVisitXSidebarData(callback) {
		getMyVisitXSidebarData(callback);
	},

	/**
	 * @param {Number} actorId
	 * @param {String} imageSize
	 * @param {Boolean} placeholder
	 * @param {String} durationFormat
	 * @return {Promise}
	 */
	loadActorInterviews(
		actorId,
		imageSize = Constants.Interviews.IMAGE_SIZE_720,
		placeholder = true,
		durationFormat = Constants.Interviews.DURATION_SEC,
	) {
		return _loadActorInterviews(actorId, imageSize, placeholder, durationFormat);
	},

	/**
	 * @param {Number} first
	 * @param {String} order
	 * @return {Promise}
	 */
	load365InteractiveContent(first, order) {
		return doVxqlRequest(InteractiveContent365, { first, order });
	},
	/**
	 * @param {String} date
	 * @param {Boolean} isMobile
	 * @return {Promise<unknown>}
	 */
	loadEventConfig(date, isMobile) {
		// check saved promise first
		if (null !== eventConfigPromise) {
			return eventConfigPromise;
		}

		// save promise instance
		eventConfigPromise = doVxqlRequest(DailyBonusEventConfig, { date, isMobile }, { cache: 1 });

		// and return it
		return eventConfigPromise;
	},

	getVideoStars(first = 100) {
		return getVideoStars(first);
	},

	claimActorGiftCalendarReward(actorId, qmDay) {
		return claimActorGiftCalendarReward(actorId, qmDay);
	},

	getLegalTexts(filter, first, offset, callback) {
		getLegalTexts(filter, first, offset, callback);
	},

	getSeo(tags, callback) {
		getSeo(tags, callback);
	},
});

VxqlStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.type) {
		case DailyBonusActionTypes.RELOAD:
			// empty caches
			_dailybonusData = {};

			// fetch data
			VxqlStore.getDailyBounes(function (result) {
				VxqlStore.emit(CHANGE_EVENTS.DailyBonusLoaded, result);
			});
			break;

		case DailyBonusActionTypes.LOAD_INTERACTIVE_CONTENT:
			VxqlStore.load365InteractiveContent(action.limit, action.order).then((result) => {
				if (result.data && result.data.dailyBonus && result.data.dailyBonus.interactive) {
					Flux.DailyBonus.setInteractiveContent(action.limit, action.order, result.data.dailyBonus.interactive);
				}
			});
			break;

		case DailyBonusActionTypes.LOAD_EVENT_CONFIG:
			VxqlStore.loadEventConfig(action.date, action.isMobile).then((result) => {
				if (result.data && result.data.dailyBonus && result.data.dailyBonus.event) {
					// dispatch
					Flux.DailyBonus.setEventConfig(action.date, action.isMobile, result.data.dailyBonus.event);
				}
				// release promise
				eventConfigPromise = null;
			});
			break;

		case Constants.ActionTypes.Actor.LOAD_CHAT_RATINGS:
			VxqlStore.getActorChatRatings(action.actorId).then((result) => {
				if (result && result.data && result.data.model && result.data.model.chatRatings) {
					Flux.Actor.cacheActorChatRatings(result.data.model.chatRatings, action.actorId);
				}
			});
			break;

		case Constants.ActionTypes.Actor.LOAD_RECOMMENDED_MODELS:
			VxqlStore.getActorRecommendedModels(action.actorId, action.first, action.isExtended, action.ageRating).then((vxql) => {
				if (vxql.data && vxql.data.model && vxql.data.model.recommendations && vxql.data.model.recommendations.models) {
					Flux.Actor.cacheActorRecommendedActors(action.actorId, vxql.data.model.recommendations.models);
				}
			});
			break;

		case Constants.ActionTypes.Actor.LOAD_INTERVIEWS:
			VxqlStore.loadActorInterviews(action.actorId, action.imageSize, action.placeholder, action.durationFormat).then(function (interviews) {
				if (interviews.data.model.interviews) {
					Flux.Actor.saveInterviewsInCache(
						interviews.data.model.interviews,
						action.actorId,
						action.imageSize,
						action.placeholder,
						action.durationFormat,
					);
				}
			});
			break;

		default:
	}
});

// sub stores
VxqlStore.VXGame = VXGameVxqlStore;

export default VxqlStore;

export { doVxqlRequest };
